window.addEventListener('DOMContentLoaded', (event) => {
    if (!window.listItemScript) {
        const featuredCollection = document.querySelector('.js-featured-collection');
        const productCards = featuredCollection.querySelectorAll('product-card');
        const customerData = JSON.parse(document.querySelector('.js-customer-json')?.innerHTML);
        const templateData = JSON.parse(document.querySelector('.js-template-json')?.innerHTML);
        const collectionId = document.querySelector('.js-collection-data').dataset.collectionId;
        const collectionHandle = document.querySelector('.js-collection-data').dataset.collectionHandle;
        let page_type = '';

        if (templateData.name == 'index') {
            page_type = 'homepage'
        } else if (templateData.name == 'collection') {
            page_type = 'collection page'
        } else if (templateData.name == 'product') {
            page_type = 'product detail page'
        } else if (templateData.name == 'page') {
            if (templateData.suffix == 'add-more-save-more') {
                page_type = 'bundle builder'
            } else {
                page_type = templateData.suffix || 'other'       
            }
        } else {
            page_type = templateData.suffix || 'other'
        }

        const sentProducts = new Set();

        const onElementVisible = (elements, callback) => {
            const observer = new IntersectionObserver((entries, observer) => {
                let visibleProducts = [];

                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const productElement = entry.target;
                        const productData = JSON.parse(productElement.querySelector('[data-product-json]').innerHTML);

                        if (!sentProducts.has(productData.id)) {
                            sentProducts.add(productData.id);
                            visibleProducts.push({
                                item_id: productData.id,
                                item_name: productData.title,
                                coupon: "",
                                discount: productData.compare_at_price ? (Number(productData.compare_at_price) - Number(productData.price)) / 100 : 0,
                                index: Array.from(elements).indexOf(productElement) + 1,
                                item_brand: productData.vendor,
                                item_category: productElement.querySelector('[data-product-json]').dataset.category1,
                                item_category2: productElement.querySelector('[data-product-json]').dataset.category2,
                                item_category3: productData.compare_at_price ? (Number(productData.compare_at_price) - Number(productData.price)) / Number(productData.compare_at_price) * 100 : 0,
                                item_category4: productElement.querySelector('[data-product-json]').dataset.size,
                                item_category5: productElement.querySelector('[data-product-json]').dataset.category3,
                                item_list_id: collectionId,
                                item_list_name: collectionHandle,
                                item_variant: (productElement.querySelector('[data-product-json]').dataset.colors).toString(),
                                price: Number(productData.price) / 100,
                                quantity: 1,
                                style_number: productElement.querySelector('[data-product-json]').dataset.styleNumber ? productElement.querySelector('[data-product-json]').dataset.styleNumber : '',
                                sku_id: productElement.querySelector('[data-product-json]').dataset.sku ? productElement.querySelector('[data-product-json]').dataset.sku : '',
                                variant_id: productElement.querySelector('[data-product-json]').dataset.variantId ? productElement.querySelector('[data-product-json]').dataset.variantId : ''
                            });
                        }
                    }
                });

                if (visibleProducts.length > 0) {
                    callback(visibleProducts);
                }
            }, { threshold: 0.8 });

            elements.forEach(element => observer.observe(element));
        };

        onElementVisible(productCards, (visibleProducts) => {
            dataLayer.push({ ecommerce: null });

            dataLayer.push({
                event: "view_item_list",
                membership_status: customerData.membership_status,
                ...window.intelligemsMeta,
                ...(customerData.id && { userId: customerData.id }),
                page_type: page_type,
                login_status: customerData.has_account ? "loggedin" : "non_loggedin",
                in_stock: "", // check with Jigar
                ecommerce: {
                    item_list_id: collectionId,
                    item_list_name: collectionHandle,
                    currency: templateData.currency,
                    items: visibleProducts
                }
            });
        });

        window.listItemScript = true;
    }
});
